import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import { presentationOptions } from '@/constants/states';
import paging, { onCategoryScroll } from '@/hooks/paging';
import CardsHeader from '@/components/cards/CardsHeader';
import RolesTable from '../components/RolesTable';
import RolesPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/RolesPanelContainer';
import RolesFilters from './RolesFilters';
import RoleCards from '../components/RoleCards';

const RolesPanelFull = ({
  canCreate,
  canRead,
  category,
  currentPage,
  display,
  fetchData,
  newRole,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  roles,
  togglePresentation,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);
  return (
    <RolesPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-roles-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <RolesFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <RoleCards
          canCreate={canCreate}
          category={category}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={roles}
          newRole={newRole}
          readErrors={readErrors}
          readStatus={readStatus}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <RolesTable
        allowCreate={canCreate}
        category={category}
        currentPage={currentPage}
        fetchData={fetchData}
        newRole={newRole}
        pageCount={pageCount}
        pageSize={pageSize}
        readErrors={readErrors}
        readStatus={readStatus}
        roles={roles}
        togglePresentation={togglePresentation}
        total={total}
      />
      )}
    </RolesPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesPanelFull);
